import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('AnswerPreview');

Factory.define('AnswerPreviewWithDefaults')
  .extend('AnswerPreview')
  .attr('answerId', 'default-answer-id');



// WEBPACK FOOTER //
// ./factories/answer_preview_factory.js